import React from 'react';

// Update QuizActionsBar Props interface
type Props = {
  currentPage: number;
  totalPages?: number; // Add this
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  onSave: () => void;
  onSummary: () => void;
  onFinish: () => void;
  saving?: boolean;
  submitting?: boolean;
  className?: string;
};

// And update the component to show page info
const QuizActionsBar: React.FC<Props> = ({
                                           currentPage,
                                           totalPages,
                                           canGoPrev,
                                           canGoNext,
                                           onPrev,
                                           onNext,
                                           onSave,
                                           onSummary,
                                           onFinish,
                                           saving,
                                           submitting,
                                           className
                                         }) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1rem',
        backgroundColor: '#f9fafb',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        marginTop: '1rem',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {totalPages && totalPages > 1 && (
          <span style={{ fontSize: '0.9rem', color: '#666' }}>
            Page {currentPage + 1} of {totalPages}
          </span>
        )}
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button className="btn btn-outline" onClick={onPrev} disabled={!canGoPrev || submitting}>
            &larr; Previous
          </button>
          <button className="btn btn-outline" onClick={onNext} disabled={!canGoNext || submitting}>
            Next &rarr;
          </button>
        </div>
      </div>
      <button className="btn btn-danger" onClick={onFinish} disabled={submitting}>
        {submitting ? 'Saving...' : 'Finish Attempt...'}
      </button>

      {/* Existing styles */}
      <style>{`
        .btn { padding: 0.6rem 1.2rem; font-size: 0.9rem; font-weight: 600; border-radius: 8px; border: 1px solid transparent; cursor: pointer; transition: all 0.2s; }
        .btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .btn-outline { background-color: #fff; border-color: #ccc; color: #333; }
        .btn-outline:hover:not(:disabled) { background-color: #f0f0f0; border-color: #bbb; }
        .btn-danger { background-color: #d32f2f; color: white; border-color: #d32f2f; }
        .btn-danger:hover:not(:disabled) { background-color: #b71c1c; }
      `}</style>
    </div>
  );
};

export default QuizActionsBar;